import { useState } from "react";
import { useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { clinicalHistoryState } from "../atoms";
import { ProfileService } from "src/services/patient/profile";
import { userState } from "src/store/user/userState";

export default function useClinicalHistoryLoader() {
  const [loading, setLoading] = useState(false);
  const [clinicalHistory, setClinicalHistory] =
    useRecoilState(clinicalHistoryState);
  const [serviceCodes, setServiceCodes] = useState([]);
  const [filteredClinicalHistory, setFilteredClinicalHistory] =
    useState(clinicalHistory);

  const user = useRecoilValue(userState);
  const loadClinicalHistory = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        console.log("Loading clinical history...", user);
        const release = snapshot.retain();
        setLoading(true);
        try {
          if (user.payload?.uswRut) {
            const response = await ProfileService.getClinicHistory(
              user.payload.uswRut
            );
            setClinicalHistory(response.data);
            setFilteredClinicalHistory(response.data);
            getServiceCodes(response.data);
          }
        } catch (error) {
          // catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    []
  );

  const getServiceCodes = (services) => {
    const codes = [];
    services.forEach((service) => {
      if (
        !codes.find((code) => code.codigoServicio === service.codigoServicio)
      ) {
        codes.push({
          codigoServicio: service.codigoServicio,
          servicio: service.servicio,
        });
      }
    });
    setServiceCodes(codes);
  };

  return {
    loading,
    clinicalHistory,
    filteredClinicalHistory,
    setFilteredClinicalHistory,
    serviceCodes,
    loadClinicalHistory,
  };
}
